export default __webpack_public_path__ + "static/media/big_home_icon.e1fec791.png";